/**
 * LoadingIndicator Component
 *
 * Animated loading indicator with pulsing dots.
 * Used to show AI is processing/responding.
 */

import React, { memo } from 'react';
import { motion } from 'framer-motion';

const LoadingIndicator = memo(() => (
  <div className="flex items-center gap-1.5 p-1.5">
    <motion.div className="relative">
      <motion.div
        className="w-1.5 h-1.5 bg-emerald-400 rounded-full"
        animate={{
          scale: [1, 1.5, 1],
          opacity: [1, 0.7, 1]
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div
        className="absolute inset-0 w-1.5 h-1.5 bg-emerald-400 rounded-full"
        animate={{
          scale: [1, 2.5, 1],
          opacity: [0.7, 0, 0.7]
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </motion.div>
    <motion.div
      className="w-1.5 h-1.5 bg-emerald-400/60 rounded-full"
      animate={{
        scale: [1, 1.5, 1],
        opacity: [0.6, 0.4, 0.6]
      }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut",
        delay: 0.15
      }}
    />
    <motion.div
      className="w-1.5 h-1.5 bg-emerald-400/40 rounded-full"
      animate={{
        scale: [1, 1.5, 1],
        opacity: [0.4, 0.2, 0.4]
      }}
      transition={{
        duration: 1.5,
        repeat: Infinity,
        ease: "easeInOut",
        delay: 0.3
      }}
    />
  </div>
));

LoadingIndicator.displayName = 'LoadingIndicator';

export default LoadingIndicator;
